module.exports = __webpack_public_path__ + "img/01.e3e1bb07.png";